<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <group-role-form id="group-role-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource" />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import { handleGeneralXhrError } from '../../helpers'
import GroupRoleForm from './GroupRoleForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        GroupRoleForm,
    },
    computed: {
        pageTitle() {
            return `Group Role | ${this.resource?.label}`
        }
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/group-roles/${this.$route.params.id}`)
                .then(response => {
                    this.resource = response.data.data
                })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
    },
}
</script>